import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartComponent } from './cart.component';
import { SharedModule } from './../shared/shared.module';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ReactiveFormsModule } from '@angular/forms';
import { CivilModule } from '../civil/civil.module';
import { CartAbandonmentWarningComponent } from './cart-abandonment-warning/cart-abandonment-warning.component';
import { CartPleadsGridComponent } from './cart-pleads-grid/cart-pleads-grid.component';
import { CivilSearchService } from '../civil/civil-search.service';
import { CartService } from './cart.service';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    PopoverModule,
    SharedModule,
    ReactiveFormsModule,
    CivilModule
  ],
  declarations: [CartComponent, CartPleadsGridComponent, CartAbandonmentWarningComponent],
  exports: [CartComponent, CartAbandonmentWarningComponent],
  providers: [CivilSearchService, CartService],
  entryComponents: [CartAbandonmentWarningComponent]
})
export class CartModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart.module.ts